import { useState } from 'react';

import { useAuth } from './store';
import { api } from '../../lib/api';
import { toast } from '../../components/ui/toast';

/**
 * Persistent notice for a signed-in user whose email isn't verified yet (SRS §6.2/§8.5).
 * Until they confirm, guest orders placed with their address aren't adopted.
 */
export function VerifyEmailBanner(): JSX.Element | null {
  const user = useAuth((s) => s.user);
  const [busy, setBusy] = useState(false);

  if (!user || user.emailVerifiedAt) return null;

  async function resend() {
    setBusy(true);
    try {
      await api.post('/auth/resend-verification', {});
      toast.success('Verification link sent — check your inbox.');
    } catch {
      toast.error('Could not resend right now. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="border-b border-warning/30 bg-warning/10">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2 text-center text-sm text-warning">
        <span>Please confirm your email to secure your account and see all your orders.</span>
        <button
          type="button"
          onClick={() => void resend()}
          disabled={busy}
          className="font-medium underline underline-offset-2 disabled:opacity-60"
        >
          {busy ? 'Sending…' : 'Resend link'}
        </button>
      </div>
    </div>
  );
}
